/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { storiesOf } from '@storybook/react';
import ConfirmationModal from './ConfirmationModal';

storiesOf('Common/Modals/ConfirmationModal', module)
  .add('View', () => (
    <ConfirmationModal
      show
      title="Title"
      onClose={() => {}}
      onConfirm={() => {}}
    >
      Message
    </ConfirmationModal>
  ));




/** WEBPACK FOOTER **
 ** ./src/components/common/Modals/ConfirmationModal/ConfirmationModal.stories.jsx
 **/